export default "__VITE_ASSET__C6MH3IQj__"